import React from 'react'
import PropTypes from 'prop-types'

class CheckoutComplete extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    e.preventDefault();
    this.props.onCompleteCheckout(this.props.placeOrderDetails);
  }

  render() {
    return (
      <div className={`summary-complete-checkout text-center ${this.props.additionalClassname && this.props.additionalClassname}`}>
        <a
          href=""
          className='btn btn-primary btn-block'
          disabled={this.props.isPlaceOrderPending}
          onClick={(e) => this.onClick(e)}
          style={{ width: '90%', whiteSpace: 'normal' }}
        >
          {/* This one is invisible. It's just for spacing */}
          <span
            style={{
              lineHeight: '1.4em',
              visibility: 'hidden',
              marginRight: 5
            }}
            className='fa fa-spinner'></span>
          {this.props.buttonText}
          <span
            style={{
              lineHeight: '1.4em',
              visibility: this.props.isPlaceOrderPending ? 'visible' : 'hidden',
              marginLeft: 5
            }}
            className='fa fa-spin fa-spinner'></span>
        </a>
      </div>
    );
  }
}

CheckoutComplete.propTypes = {
  onCompleteCheckout: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
  placeOrderDetails: PropTypes.object.isRequired,
  additionalClassname: PropTypes.string,
  isPlaceOrderPending: PropTypes.bool
}



export default CheckoutComplete